import React from "react"
import useWalletConnect from "@/hooks/useWalletConnect"
import View from "./view"

const Container = () => {
  const { connected } = useWalletConnect()

  if (!connected) return <></>

  return <View />
}

export default Container
